import * as angular from "angular";
import {PdfFormTextTagType} from "../types/pdf-form-text-tag.type";
import {PdfFormTemplatesRequestsService} from "./pdf-form-templates-requests.service";
import {PdfFormTemplateModel} from "../models/pdf-form-template.model";

export class PdfFormTemplatesDialogService {

  constructor(private $mdDialog,
              private pdfFormTemplatesRequestsService: PdfFormTemplatesRequestsService) {

  }

  onAddDocument() {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/import-documents-dialog.html').default,
      controller: function ($scope) {
        $scope.file = undefined;
        $scope.loading = false;
        $scope.pdfFormTemplate = undefined;
        $scope.viewType = 'UPLOAD' // UPLOAD/READY
        $scope.header = 'Add A Document';

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onTagSelect = (pdfFormField, pdfFormTextTag) => {
          pdfFormField.pdfFormTextTag = pdfFormTextTag;
        }

        $scope.onUpload = () => {
          $scope.loading = true;
          self.pdfFormTemplatesRequestsService.uploadOne($scope.file)
            .then((pdfFormTemplate) => {
              $scope.pdfFormTemplate = pdfFormTemplate;
              $scope.viewType = 'READY';
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.pdfFormTemplate);
            }
          }
        }

      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  onEditDocument(pdfFormTemplate: PdfFormTemplateModel) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/import-documents-dialog.html').default,
      controller: function ($scope) {
        $scope.file = undefined;
        $scope.loading = false;
        $scope.pdfFormTemplate = angular.copy(pdfFormTemplate);
        $scope.viewType = 'READY' // UPLOAD/READY
        $scope.header = 'Update A Document';

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onTagSelect = (pdfFormField, pdfFormTextTag) => {
          pdfFormField.pdfFormTextTag = pdfFormTextTag;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.pdfFormTemplate);
            }
          }
        }

      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

}

angular
  .module('bringoz.admin.document-management')
  .service('pdfFormTemplatesDialogService', PdfFormTemplatesDialogService);
